export class SortSelect {
  constructor(selector) {
    this.selectInput = jQuery(selector);

    if (this.selectInput) {

      /**
       * data attribute 
       * @param {string} dt 
       * asc or desc
       * @param {string} by 
       * returns sorted elements
       * @returns {array}
       */
      jQuery.fn.mbSort = function (dt, by) {
        this
          .children('.card')
          .sort((a, b) => {
            if (typeof jQuery(a).data(dt + '-custom') !== 'undefined') {
              dt = dt + '-custom';
            }

            if (by == 'asc') {
              if (dt == 'type' || dt == 'type-custom') {
                if (jQuery(a).data(dt) == jQuery(b).data(dt)) {
                  return (jQuery(a).find('h3').html() < jQuery(b).find('h3').html()) ? -1 : 1;
                }
                return jQuery(a).data(dt) - jQuery(b).data(dt) || -1;
              }
              else {
                return jQuery(a).data(dt) - jQuery(b).data(dt) || -1;
              }
            } else {
              return jQuery(b).data(dt) - jQuery(a).data(dt) || -1
            }
          })
          .appendTo(this);

        return this;
      }

      // init select2 
      jQuery(this.selectInput).select2({
        minimumResultsForSearch: -1,
        placeholder: "Sort by...",
        width: '100%',
      });

      if (cur_sort !== '') {
        jQuery(this.selectInput).val(cur_sort).trigger('change');
      }

    }
  }

  sort(selected = null) {
    if (selected == null) {
      selected = jQuery(this.selectInput).val();
    }

    if (selected !== null) {
      switch (selected) {
        case 'rent-low':
          var dt = 'price', by = 'asc';
          break;
        case 'rent-high':
          var dt = 'price', by = 'desc';
          break;
        case 'availability':
          var dt = 'available', by = 'desc';
          break;
        case 'sq-low':
          var dt = 'sq-footage', by = 'asc';
          break;
        case 'sq-high':
          var dt = 'sq-footage', by = 'desc';
          break;
        default:
          break;
      }
      jQuery('.floorplan-wrap').mbSort(dt, by);

      // update flex elements by order css
      jQuery('.card.floorplan').each(function (i) {
        jQuery(this).css('order', i);
      });
    }
  }
}